import { render, staticRenderFns } from "./invoiceHeader.vue?vue&type=template&id=a046323c&scoped=true"
import script from "./invoiceHeader.vue?vue&type=script&lang=js"
export * from "./invoiceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a046323c",
  null
  
)

export default component.exports